import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-header-left-content',
    templateUrl: './eui-card-header-left-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderLeftContentComponent {

    @HostBinding('class') string = 'eui-card-header__left-content';

    constructor( ) {
    }
}
